import React from 'react';

import { Box, Button, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import BgVideo from '../../../assets/video/main_bg.mp4';
import StyledBanner from './styles';

const Banner = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const label1 = t('banner-label-one');
  const label2 = t('banner-label-two');
  const label3 = t('banner-label-three');
  const label3Mobile = t('banner-label-three');

  return (
    <StyledBanner>
      <Box className="homeBg" sx={{ display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' } }}>
        <video width="100%" autoPlay loop muted playsInline className="videoElement">
          <source src={BgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box>
      <Box className="homeContent">
        <div className="card">
          {/* <Box className="iconBrandLogo" sx={{ height: '170px' }}>
            <IconBrandLogo />
          </Box> */}
          <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'center', lg: 'left', xl: 'left' }, zIndex: 1 }}>
            <Box
              sx={{
                display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' },
                position: 'absolute',
                // width: '240%',
                // right: '-83px',
                width: '180%',
                right: '4px',
                marginBottom: '100px',
              }}
            >
              <video width="100%" autoPlay loop muted playsInline>
                <source src={BgVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Box>
            <Box
              sx={{
                top: 'unset',
                [theme.breakpoints.down('lg')]: {
                  padding: '0 10px',
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  // top: '400px',
                  top: '360px',
                  // bottom: '190px',
                },
              }}
              className='content'
            >
              <Typography
                variant="h6"
                component="h1"
                sx={{
                  // color: 'rgba(255, 255, 255, 0.7)',
                  color: '#000000',
                  fontWeight: 900,
                  fontSize: '48px',
                  // textShadow:
                  //   '1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white, 0 1px 0 white, 0 -1px 0 white, 1px 0 0 white, -1px 0 0 white',
                  // textShadow: '-1px 0 #ffffff, 0 1px #ffffff, 1px 0 #ffffff, 0 -1px #ffffff',
                  WebkitTextStrokeWidth: '0.4px', // Apply text stroke width
                  WebkitTextStrokeColor: '#FFF', // Apply text stroke color
                  lineHeight: "57.28px",
                  // fontFamily: 'Pretendard',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '25px',
                    lineHeight: '29.83px',
                    mt: 2,
                  },
                }}
              >
                {label1}
              </Typography>
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: '96px',
                  fontWeight: '900',
                  lineHeight: '114.56px',
                  mt: 2,
                  mb: 1,
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '60px',
                    lineHeight: '71.6px',
                    mt: 2,
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                    },
                  }}
                // viewport={{ once: true }}
                >
                  {label2}
                </motion.div>
              </Typography>
              <Box
                sx={{
                  // width: '400px',
                  [theme.breakpoints.down('lg')]: {
                    width: '100%',
                    padding: '0 20px',
                  },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    mb: 4,
                    wordWrap: 'break-word',
                    fontWeight: 800,
                    fontSize: '20px',
                    lineHeight: '23.87px',
                    [theme.breakpoints.down('lg')]: {
                      display: 'none',
                    },
                  }}
                >
                  {parse(label3)}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 4,
                    wordWrap: 'break-word',
                    fontWeight: 800,
                    fontSize: '20px',
                    lineHeight: '26px',
                    display: 'none',
                    [theme.breakpoints.down('lg')]: {
                      display: 'flex',
                      fontWeight: 600,
                      fontSize: '18px',
                      lineHeight: '23.4px',
                      justifyContent: 'center',
                      mt: 2,
                      mb: 5,
                    },
                  }}
                  className="label3"
                >
                  {parse(label3Mobile)}
                </Typography>
              </Box>
              <Button
                variant="contained"
                onClick={() => navigate('/contact')}
                sx={{
                  backgroundColor: '#00FF00',
                  color: 'black',
                  fontSize: '16px',
                  fontWeight: '800',
                  borderRadius: '5px',
                  padding: '10px 30px',
                  '&:hover': {
                    backgroundColor: '#00cc00',
                  },
                  [theme.breakpoints.down('lg')]: {
                    // width: '98%',
                    // marginBottom: '30px',
                  },
                }}
              >
                {t('banner-button')}
              </Button>
            </Box>
          </Box>
        </div>

        {/* <Container maxWidth="lg">
          <motion.div
            className="card"
            initial={{
              opacity: 0,
              y: 290,
            }}
            whileInView={{
              opacity: 1,
              y: 0, // Slide in to its original position
              transition: {
                duration: 2, // Animation duration
              },
            }}
            // viewport={{ once: true }}
          >
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
              <Box className="bannerText" mt={2} mx={8}>
                {bannerText}
              </Box>
              <Box mt={5}>
                <Button hasEndIcon IconEnd={ArrowForwardIosIcon} text="Get Started" color={COLOR.DEFAULT} />
              </Box>
            </Box>
          </motion.div>
        </Container> */}
      </Box>
    </StyledBanner>
  );
};

export default Banner;
